(() => {
  const HEADER_SELECTOR = '.section-header-navigation';
  const TARGET_SELECTOR = '#MainContent, .wrapper-footer';
  let frame = 0;
  let observer;

  const clearTarget = (target) => {
    target.classList.remove('pbc-sticky-content-boundary');
    target.style.removeProperty('--pbc-content-clip-top');
  };

  const updateBoundary = () => {
    frame = 0;

    const header = document.querySelector(HEADER_SELECTOR);
    const targets = document.querySelectorAll(TARGET_SELECTOR);

    if (!header || !targets.length) {
      targets.forEach(clearTarget);
      return;
    }

    const isSticky = header.classList.contains('shopify-section-header-sticky');
    const isHidden = header.classList.contains('shopify-section-header-hidden');
    const isShown = header.classList.contains('shopify-section-header-show');
    const headerRect = header.getBoundingClientRect();
    const isVisibleSticky = isSticky && !isHidden && (isShown || headerRect.top >= -1);
    const boundary = isVisibleSticky ? Math.max(0, Math.ceil(headerRect.height)) : 0;

    targets.forEach((target) => {
      if (!boundary) {
        clearTarget(target);
        return;
      }

      const rect = target.getBoundingClientRect();
      const clipTop = Math.max(0, Math.min(rect.height, boundary - rect.top));

      if (clipTop > 0) {
        target.style.setProperty('--pbc-content-clip-top', clipTop + 'px');
        target.classList.add('pbc-sticky-content-boundary');
      } else {
        clearTarget(target);
      }
    });
  };

  const scheduleBoundary = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(updateBoundary);
  };

  const observeHeader = () => {
    if (observer) observer.disconnect();
    const header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;

    observer = new MutationObserver(scheduleBoundary);
    observer.observe(header, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  };

  const initialise = () => {
    observeHeader();
    scheduleBoundary();
  };

  window.addEventListener('scroll', scheduleBoundary, { passive: true });
  window.addEventListener('resize', scheduleBoundary, { passive: true });
  window.addEventListener('load', initialise, { once: true });
  document.addEventListener('shopify:section:load', initialise);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
